export default angular
  .module('doxy.common.directives.ngIfDelayed', [])
  .directive('delayedIf', function ($compile, $timeout) {
    return {
      restrict: 'A',
      scope: false,
      link: function (scope, elem, attr) {
        const delay = attr.delay;
        const key = '_delayedIf' + Math.random().toString(36).substring(7);
        let timeoutPromise;

        scope[key] = undefined;
        scope.$watch(attr.delayedIf, function (newValue, oldValue) {
          $timeout.cancel(timeoutPromise);
          if (!newValue && oldValue) {
            timeoutPromise = $timeout(() => (scope[key] = false), delay);
          } else {
            scope[key] = newValue;
          }
        });

        elem.attr('ng-if', key);
        elem.removeAttr('delayed-if');
        $compile(elem)(scope);
      },
    };
  }).name;
